import { Showable } from "../../../mixins/Showable";
import { DealCompleteResultsContent } from "./DealCompleteResultsContent";
import { DealCompleteDealsContent } from "./DealCompleteDealsContent";
import { ApplyScalingBias } from "../../../utils/ApplyScalingBias";
import { AppSettings } from "../../managers/AppSettings";
import { DealCompleteTricksContent } from "./DealCompleteTricksContent";
import { DealCompleteHandsContent } from "./DealCompleteHandsContent";
import { ContentsScrollPane } from "../ContentsScrollPane";
import { ScrollPaneTitledListContent } from "./ScrollPaneTitledListContent";
import { AppLocalization } from "../../localization/AppLocalization";
import { DealCompleteLocData } from "../../../types/types";


export enum DealCompleteContentId {
    /**
     * Screen with Deal stats
     */
    RESULTS,
    /**
     * Screen with stats on all deals (state of whole game/deals)
     */
    DEALS,
    TRICKS,
    HANDS,
}

// get ts linting
export interface DealCompleteContentScroll extends Showable { }

/**
 * multiple category contents stacked on top of eachother in containers.
 * (EXTENDS) scrollpane for the above (overlay, mask, above contents in another container)
 * sets data (knows all datamodels and howto redistribute) for the above and 
 * can sum GetSize on all containers as this.content.GetSize
 * 
 * @param cullItems Uses custom culling to cull items (or not). Had some issues culling particles later created.
 */
export class DealCompleteContentScroll
    extends ContentsScrollPane {
    public override Init(
        cullItems: boolean = true,
        referenceWidth: number = undefined,
    ): void {
        super.Init(cullItems, referenceWidth);

        this.contentsScrollData[DealCompleteContentId.RESULTS] = {};
        this.contentsScrollData[DealCompleteContentId.DEALS] = {};
        this.contentsScrollData[DealCompleteContentId.TRICKS] = {};
        this.contentsScrollData[DealCompleteContentId.HANDS] = {};

        this.excessScrollAmount.Set(0, 0, 5, 350);

        // this.UpdateFromLocalizationChange();
    }

    public override UpdateFromLocalizationChange(): void {
        // Cache localizations for the title (for scrolling purposes)
        const dealCompleteLocData: DealCompleteLocData = AppLocalization.GetVariationData().dealComplete;
        let title = dealCompleteLocData.results.title.itemLabel;
        // console.log(title);
        this.contentsScrollData[DealCompleteContentId.RESULTS].title = title;
        this.contentsScrollData[DealCompleteContentId.RESULTS].capitalizedTitle = title.toUpperCase();

        title = dealCompleteLocData.deals.title.itemLabel;
        this.contentsScrollData[DealCompleteContentId.DEALS].title = title;
        this.contentsScrollData[DealCompleteContentId.DEALS].capitalizedTitle = title.toUpperCase();

        title = dealCompleteLocData.tricks.title.itemLabel;
        this.contentsScrollData[DealCompleteContentId.TRICKS].title = title;
        this.contentsScrollData[DealCompleteContentId.TRICKS].capitalizedTitle = title.toUpperCase();

        title = dealCompleteLocData.hands.title.itemLabel;
        this.contentsScrollData[DealCompleteContentId.HANDS].title = title;
        this.contentsScrollData[DealCompleteContentId.HANDS].capitalizedTitle = title.toUpperCase();

        // update view od contents
        // update content titles and headers (all static texts)
        this.contents.forEach(content => {
            content.UpdateFromLocalizationChange();
        });
    }

    public Build(): void {
        // >> build overlay
        // > build content container
        // > build mask
        super.Build();

        let catContent = new DealCompleteResultsContent(this.scene);
        catContent.Init();
        catContent.Build();
        this.content.add(catContent);
        this.contents[DealCompleteContentId.RESULTS] = catContent;
        let catContent2 = new DealCompleteDealsContent(this.scene);
        catContent2.Init();
        catContent2.Build();
        this.content.add(catContent2);
        this.contents[DealCompleteContentId.DEALS] = catContent2;

        let catContent3 = new DealCompleteTricksContent(this.scene);
        catContent3.Init();
        catContent3.Build();
        this.content.add(catContent3);
        this.contents[DealCompleteContentId.TRICKS] = catContent3;

        let catContent4 = new DealCompleteHandsContent(this.scene);
        catContent4.Init();
        catContent4.Build();
        this.content.add(catContent4);
        this.contents[DealCompleteContentId.HANDS] = catContent4;
    }
}